<!-- MODAL Editar Datos personales -->
<div style="overflow-y: auto" mdbModal #datosEditarPersonales="mdb-modal" class="modal fade" id="basicExample"
    tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: false }">
    <div class="modal-dialog modal-fluid" style="max-width: 60%;" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Editar Datos personales
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="datosEditarPersonales.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <!-- [optionsCanal]="optionsCanal" -->
            <div class="modal-body">
                <app-clientes-form-datos-personales mode="EDIT" [optionsTipoCliente]="optionsTipoCliente" [optionsCanal]="optionsCanal"
                    (onShowModalBloqueo)="showModalBloqueo()"
                    (onBuscaDatosHistorialBloqueo)="showHistorial()">
                </app-clientes-form-datos-personales>
            </div>

            <div class="modal-footer justify-content-between">
                <button type="button" size="sm" class="btn btn-sm btn-default waves-light" data-dismiss="modal"
                    (click)="datosEditarPersonales.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <button type="button" size="sm" class="btn btn-sm btn-secondary waves-light" mdbWavesEffect
                    (click)="editarDatosPersonales()">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL Bloquear/Desbloquear -->
<div style="overflow-y: auto" mdbModal #bloquearDesbloquear="mdb-modal" class="modal fade" id="basicExample"
    tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Motivo de Bloqueo
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"
                    (click)="bloquearDesbloquear.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <form [formGroup]="formAgregaBloqueo">
                <div class="modal-body">
                    <div class="row">
                        <div class="col">
                            <div class="md-form">
                                <input type="hidden" id="formBloqueoEsBloqueo" formControlName="esBloqueo" />
                            </div>
                            <div class="md-form">
                                <input value="" type="text" id="motivo" class="form-control"
                                    placeholder="Escribe aquí el motivo" required formControlName="motivo"
                                    maxlength="500" #motivo />
                                <label for="motivo">Motivo</label>
                                <div *ngIf="
                    formAgregaBloqueo.get('motivo').invalid &&
                    (formAgregaBloqueo.get('motivo').dirty ||
                      formAgregaBloqueo.get('motivo').touched)
                  ">
                                    <mdb-error *ngIf="formAgregaBloqueo.get('motivo').errors.required">
                                        Debe ingresar el motivo de bloqueo o desbloqueo
                                    </mdb-error>
                                    <mdb-error *ngIf="formAgregaBloqueo.get('motivo').errors.minlength">
                                        El motivo debe tener un mínimo de 7 caracteres
                                    </mdb-error>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </form>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="bloquearDesbloquear.hide()" mdbWavesEffect>
                    Cerrar
                </button>
                <button type="button" class="btn btn-secondary waves-light" mdbWavesEffect
                    (click)="agregaBloqueo(); bloquearDesbloquear.hide()" [disabled]="!formAgregaBloqueo.valid">
                    Guardar
                </button>
            </div>
        </div>
    </div>
</div>

<!-- MODAL historial -->
<div style="overflow-y: auto" mdbModal #historial="mdb-modal" class="modal fade" id="basicExample" tabindex="-1"
    role="dialog" aria-labelledby="myModalLabel" aria-hidden="true"
    [config]="{ backdrop: true, ignoreBackdropClick: true }">
    <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title w-100 text-left" id="myModalLabel">
                    Historial de bloqueos
                </h4>
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="historial.hide()">
                    <span aria-hidden="true">×</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="row">
                    <div class="col">
                        <table class="table table-striped table-hover table-sm align-middle">
                            <thead class="grey lighten-2">
                                <tr>
                                    <th scope="col">Fecha</th>
                                    <th scope="col">Hora</th>
                                    <th scope="col">Usuario</th>
                                    <th scope="col">Acción</th>
                                    <th scope="col">Motivo</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let his of listaBloqueoHistorico">
                                    <td>{{ his.fecha }}</td>
                                    <td>{{ his.hora }}</td>
                                    <td>{{ his.nombre_usuario }}</td>
                                    <td>{{ his.glosabloqueo }}</td>
                                    <td>{{ his.motivo }}</td>
                                </tr>
                            </tbody>
                            <tfoot>
                                <tr>
                                    <th colspan="5">
                                        Página {{ paginaActualBloqueo }} de
                                        {{ totalPaginasBloqueo }} ({{ totalRegistrosBloqueo }}
                                        registros)
                                        <div class="btn-toolbar" role="toolbar">
                                            <div class="btn-group">
                                                <div *ngIf="paginaActualBloqueo != 1">
                                                    <button mdbBtn type="button" color="primary" mdbWavesEffect
                                                        size="sm" (click)="retrocedePaginaGrillaBloqueo()">
                                                        <mdb-icon fas icon="angle-left" class="mr-1"></mdb-icon>Anterior
                                                    </button>
                                                </div>
                                                &nbsp;
                                                <div *ngIf="paginaActualBloqueo < totalPaginasBloqueo">
                                                    <button mdbBtn type="button" color="primary" mdbWavesEffect
                                                        size="sm" (click)="avanzaPaginaGrillaBloqueo()">
                                                        Siguiente
                                                        <mdb-icon fas icon="angle-right" class="ml-1"></mdb-icon>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
            <div class="modal-footer justify-content-between">
                <button type="button" class="btn btn-default waves-light" data-dismiss="modal"
                    (click)="historial.hide()" mdbWavesEffect>
                    Cerrar
                </button>
            </div>
        </div>
    </div>
</div>